/**
 * Ant Design DatePicker configured to use Day.js instead of Moment.
 * Import dayjs-config first to ensure plugins (utc, timezone) are loaded.
 */
import "utils/dayjs-config";
import dayjs from "utils/dayjs-config";
import type { Dayjs } from "dayjs";
import dayjsGenerateConfig from "@rc-component/picker/es/generate/dayjs";
import generatePicker from "antd/es/date-picker/generatePicker";

// rc-picker's default getNow returns plain dayjs() (machine-local). Pre-
// migration, moment.tz.setDefault(projectZone) routed plain moment() through
// the project zone, so the picker's "today" highlight matched the rest of
// the app (project clock, schedule grids). dayjs.tz.setDefault is a no-op
// for plain dayjs(), so without this override an IST user on an EDT project
// would see the picker highlight a different "today" from the navbar for
// roughly a 9.5-hour window every day.
const config = {
  ...dayjsGenerateConfig,
  getNow: (): Dayjs => dayjs.tz()
};

const DatePicker = generatePicker<Dayjs>(config);

export { DatePicker };
export type { Dayjs };
